import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import moment from 'moment';

@Component({
  imports: [TranslateModule],
  selector: 'mps-app-footer',
  templateUrl: './mps-footer.component.html',
  styleUrls: ['./mps-footer.component.scss'],
})
export class MpsFooterComponent {
  currentYear = moment().format('Y');
}
